import React from 'react';
import { useAuth } from "../../context/auth";
import {makeStyles} from "@material-ui/core/styles";
import Dashboard from "../Overview/Overview.page";

const useStyles = makeStyles((theme)=>({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        marginTop: 10,
        marginBottom: 10
    },
}));

function Home(){

    const classes = useStyles();

    const {authUser} = useAuth();

    return (
        <div className={classes.container}>
            <Dashboard />
        </div>
    );
}

export default Home;